import React from 'react';
import PropTypes from 'prop-types';

const DashboardCardIcon = ({ icon, iconColor, backgroundColor, size, iconSize, className }) => {
  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        minWidth: size,
        borderRadius: 10,
        background: backgroundColor,
        border: '1px solid rgba(79, 128, 245, 0.28)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 10px rgba(79, 128, 245, 0.10)',
      }}
    >
      <i
        className={icon}
        style={{
          fontSize: iconSize,
          color: iconColor,
          lineHeight: 1,
        }}
      />
    </div>
  );
};

DashboardCardIcon.propTypes = {
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  size: PropTypes.number,
  iconSize: PropTypes.number,
  className: PropTypes.string,
};

DashboardCardIcon.defaultProps = {
  icon: 'bi bi-grid',
  iconColor: '#737373',
  backgroundColor: '#eaf1ff',
  size: 34,
  iconSize: 16,
  className: '',
};

export default DashboardCardIcon;
